import axios from "axios";
import router from "../router/index";
import $ from "jquery";
import Vue from "vue";
import { Message } from "element-ui";
const venues = {
  state: () => ({
    items: [],
    filter: {
      searchTerm: null,
      skip: 0,
      take: 1000,
      total: 0,
      page: 1,
      groupID: null
    },
    selectedItems: [],
    loading: true
  }),
  mutations: {
    setVenues(state, payload) {
      var dammyItems = [];
      payload.items.map(x => {
        dammyItems.push({ ...x, show: false });
      });
      state.items = dammyItems;
      state.filter.total = payload.total;
    },
    setSelectedVenues(state, payload) {
      state.selectedItems = payload;
    },
    setVenuePage(state, payload) {
      state.filter.page = payload;
      this.dispatch("getVenues");
    },
    setVenueTake(state, payload) {
      state.filter.page = 1;
      state.filter.take = payload;
      this.dispatch("getVenues");
    }
  },
  actions: {
    async getSeatingPlan(store, payload) {
      var res = await axios.post("controlpoint/getseatingplan", { id: payload });
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      }
      return res;
    },
    async updateSeatingPlan(store, payload) {
      var res = await axios.post("controlpoint/updateseatingplan", payload);
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      }
      return res;
    },
    async seatingParticipants(store, payload) {
      var res = await axios.post("participant/list", payload);
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      }
      return res;
    },
    async getControlPointAccessLogs(store, payload) {
      var res = await axios.post("controlpoint/listaccesslogs", { ...payload, skip: (payload.page - 1) * payload.take });
      return res;
    },

    async deleteControlPointAccessLog(store, payload) {
      var res = await axios.post("ControlPoint/DeleteAccessLog", {
        id: payload
      });
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
      }
      return res;
    },
    async getVenue(store, payload) {
      var res = await axios.post("controlpoint/get", { id: payload });
      return res;
    },
    async getVenues(store) {
      store.state.loading = true;
      var res = await axios.post("controlpoint/list", {
        ...store.state.filter,
        skip: (store.state.filter.page - 1) * store.state.filter.take
      });
      store.state.loading = false;
      return store.commit("setVenues", res.data.data);
    },
    async togglerVenue(store, payload) {
      var res = await axios.post("/controlpoint/ToggleISActive", {
        id: payload
      });
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
      }
      return res.data;
    },
    async deleteVenue(store, payload) {
      var res = await axios.post("controlpoint/delete", {
        id: payload
      });
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      }
      return res;
    }
  },
  getters: {}
};
export default venues;



// WEBPACK FOOTER //
// ./src/store/venues.js